import IconListCarousel from './icon-list-carousel';

export default IconListCarousel;
